if (!customElements.get("add-to-cart-form")) {
  customElements.define(
    "add-to-cart-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.currentVariant = null;
      }

      connectedCallback() {
        this.form = this.querySelector("form");
        this.idInput = this.form.querySelector("[name=id]");
        this.currentValueText = this.querySelector('#current-option-value');
        this.variantTeaserText = this.querySelector('#variant-teaser'); 
        this.variantSecondTeaserText = this.querySelector('#variant-teaser-2'); 
        this.productData = JSON.parse(document.getElementById('product-json').textContent);

        this.optionInputs = Array.from(
          this.form.querySelectorAll('input[type="radio"], select[name^="options"]')
        );
        
        this.optionInputs.forEach((input) =>
          input.addEventListener("change", this.onOptionChange.bind(this))
        );

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector(".cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onOptionChange() {
        this.updateCurrentVariant();
        this.updateInfoText();
        this.updateVarinatImageInSlider();
        this.updateVarinatImageInZoomModal();
        this.updateAddToCartButtonState();
        this.updateTeaserVisibility();
        this.updatePrice();
        this.updateVariantURL();
      }

      updateCurrentVariant() {
        const selectedOptions = this.productData.options.map((opt) => {
          const checkedInput = this.optionInputs.find(
            (el) => el.type === "radio" && el.name === `options[${opt}]` && el.checked
          );

          const selectInput = this.optionInputs.find(
            (el) => el.tagName === "SELECT" && el.name === `options[${opt}]`
          );

          if (checkedInput) return checkedInput.value;
          if (selectInput) return selectInput.value;
          return null;
        });

        const matchedVariant = this.productData.variants.find((variant) =>
          variant.options.every((optValue, i) => optValue === selectedOptions[i])
        );

        if (matchedVariant) {
          this.idInput.value = matchedVariant.id;
          this.currentVariant = matchedVariant;
        }        
      }

      updateInfoText() {
        if (!this.currentVariant) return;

        // color update
        const colorOptionIndex = this.productData.options.findIndex(opt => opt === "Color");
        if (colorOptionIndex !== -1 && this.currentValueText) {
          this.currentValueText.textContent = this.currentVariant.options[colorOptionIndex];
        }
        
        // variant teaser update
        if (this.variantTeaserText) {
          const teaser = this.currentVariant.metafields?.custom?.variant_teaser || "";
          this.variantTeaserText.innerHTML = teaser;
        }

        // variant second teaser update
        if (this.variantSecondTeaserText) {
          const secondTeaser = this.currentVariant.metafields?.custom?.variant_teaser_2 || "";
          this.variantSecondTeaserText.innerHTML = secondTeaser;
        }
      }

      updateTeaserVisibility() {
        if (!this.currentVariant) return;

        const teaserWrapper = document.querySelector('#teaser-wrapper');
        const teaser2Wrapper = document.querySelector('#teaser-2-wrapper');

        // teaser 1
        if (teaserWrapper) {
          const teaserValue = this.currentVariant.metafields?.custom?.variant_teaser;
          teaserWrapper.classList.toggle('hidden', !teaserValue);
        }

        // teaser 2
        if (teaser2Wrapper) {
          const teaser2Value = this.currentVariant.metafields?.custom?.variant_teaser_2;
          teaser2Wrapper.classList.toggle('hidden', !teaser2Value);
        }
      }


      updateVarinatImageInSlider() {
        if (!this.currentVariant) return;

        const media = this.currentVariant.featured_media
        
        if (!media) return;

        const mainImage = document.querySelector(
          '#main-media-list .product-media-slider__media-item'
        );
        const thubsImage = document.querySelector(
          '#thubs-media-list .product-media-slider__media-thumb'
        );
        
        if (!mainImage) return;

        mainImage.src = media.src;
        mainImage.srcset = '';
        mainImage.alt = media.alt || this.currentVariant.title;

        if (!thubsImage) return;

        thubsImage.src = media.src;
        thubsImage.srcset = '';
        thubsImage.alt = media.src || this.currentVariant.title;
      }

      updateVarinatImageInZoomModal() {
        if (!this.currentVariant) return;
        const productModal = document.querySelector("product-modal");
        const media = this.currentVariant.featured_media

        if (!media || !productModal) return;  

        const mainTrackImage = productModal.querySelector(".product-media-modal__media-list .product-media-modal__media-item-img");
        const thumbsTrackImage = productModal.querySelector(".embla-thumbs__container .product-media-slider__media-thumb");

        if(!mainTrackImage) return;

        mainTrackImage.src = media.src;
        mainTrackImage.srcset = '';
        mainTrackImage.alt = media.src || this.currentVariant.title;

        if(!thumbsTrackImage) return;

        thumbsTrackImage.src = media.src;
        thumbsTrackImage.srcset = '';
        thumbsTrackImage.alt = media.src || this.currentVariant.title;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();        

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        const formData = new FormData(this.form);
        const variantId = formData.get("id");

        const payload = {};
        const bundleProp = formData.get("properties[_bundle]");
        if (bundleProp) payload.properties = { _bundle: bundleProp };

        const quantity = formData.get("quantity") || 1;

        window.BIRTHDATE_CART.addVariant(
          { id: variantId },
          quantity,
          payload,
          { ensureUnique: this.dataset.ensureUnique === "true" }
        ).finally(() => {
          setTimeout(() => {
            this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.classList.remove("loading");
          }, 10);
        });
      }

      updateAddToCartButtonState() {
        if (!this.currentVariant || !this.submitButton) return;
        const buttonTextBlock = this.submitButton.querySelector('.js-add-to-cart-text');
        const availabelButtonText = this.submitButton.getAttribute('data-add-to-cart-text');
        const unavailabelButtonText = this.submitButton.getAttribute('data-unavailable-text');

        if (!this.currentVariant.available) {
          this.submitButton.setAttribute("aria-disabled", "true");
          this.submitButton.disabled = true;
          buttonTextBlock.textContent = unavailabelButtonText;
        } else {
          this.submitButton.removeAttribute("aria-disabled");
          this.submitButton.disabled = false;
          buttonTextBlock.textContent = availabelButtonText;
        }
      }

      updatePrice() {
        if (!this.currentVariant) return;

        const priceContainer = document.querySelector('.product-price-container');
        const priceEl = priceContainer.querySelector('.product-price');
        const comparePriceEl = priceContainer.querySelector('.product-compare-price');

        const price = (this.currentVariant.price / 100).toFixed(2);
        const comparePrice = this.currentVariant.compare_at_price
          ? (this.currentVariant.compare_at_price / 100).toFixed(2)
          : null;

        priceEl.textContent = `$${price}`;
        if (comparePrice) {
          comparePriceEl.textContent = `$${comparePrice}`;
          comparePriceEl.classList.remove('hidden');
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.classList.add('hidden');
        }
      }

      updateVariantURL() {
        if (!this.currentVariant) return;

        const url = new URL(window.location);
        url.searchParams.set('variant', this.currentVariant.id);
        window.history.replaceState({}, '', url);
      }
    }
  );
}
